export function buildCollectionUpdate({
  name,
  targetAmount,
  currentAmount,
  status,
  contribution,
  startDate,
  endDate,
  affectsClassBalance,
}) {
  return {
    name: String(name ?? "").trim(),
    target_amount: targetAmount === "" ? null : Number(targetAmount),
    current_amount: Number(currentAmount),
    status,
    contribution_mode: contribution.contributionMode,
    is_voluntary: contribution.isVoluntary,
    min_contribution: contribution.minContribution,
    max_contribution: contribution.maxContribution,
    start_date: startDate || null,
    end_date: endDate || null,
    affects_class_balance: affectsClassBalance !== false,
  };
}
